@if(currentRouteDay() && currentRouteDay()?.length > 0){
    @for(item of currentRouteDay(); track item.id) {
        @switch (item.status) {
            @case ("pending") {
                <map-polyline (polylineClick)="onPolylineClick($event, $index)" [path]="item.polylinesPath" [options]="remainDottedPolyLineOptions" />
            }
            @case ("running") {
                @if(projectedPoint()){
                    <map-polyline (polylineClick)="onPolylineClick($event, $index)" [path]="getRemaining(item.polylinesPath)" [options]="solidPolylineOptions" />
                    <map-polyline [path]="getRemaining(item.polylinesPath)" [options]="borderPolylineOptions" />
                    <map-polyline (polylineClick)="onPolylineClick($event, $index)" [path]="getFinished(item.polylinesPath)" [options]="finishedDottedPolyLineOptions" />
                }
                @else {
                    <map-polyline (polylineClick)="onPolylineClick($event, $index)" [path]="item.polylinesPath" [options]="solidPolylineOptions" />
                    <map-polyline [path]="item.polylinesPath" [options]="borderPolylineOptions" />
                }
            }
            @case ("finished") {
                <map-polyline (polylineClick)="onPolylineClick($event, $index)" [path]="item.polylinesPath" [options]="finishedDottedPolyLineOptions" />
            }
        }
    }
}